import CustomTagManager from '../GtmUtil';

export const commentGTM = (rating, experience) => {
  const data = {
    dataLayer: {
      event: 'feedback_submit',
      values: { EmojiValue: rating, comment: experience },
    },
  };
  CustomTagManager(data);
};

export const emailGTM = (emailValue) => {
  const data = {
    dataLayer: {
      event: 'feedback_email',
      values: { email: emailValue },
    },
  };
   CustomTagManager(data);
};
